import {
  UnknownQuestionModel,
  UnknownQuestionPaginateAPIRepsonse,
  UnknownQuestionTrainOptions,
  UnknownQuestionUpdateAPI,
} from '../components/unansweredQuestions/types'
import { QuestionImportDetailsDTO, UnknownQuestionCreateAPI, UnkownQuestionsSearchAPI } from './types'
import { PRIVATE_BASE_URL } from '../../../configs'
import API from '../../../services/api'
import { unknownQuestionsAPIMessages } from './configs'
import { alertError, alertSuccess } from '../../../api'

type GetDatasetTypesResponse = {
  datasetTypes: string[]
}

const template = (path = '', params = {}) => {
  let basePath: string
  if (path !== '') {
    basePath = `${PRIVATE_BASE_URL}/questions/${path}`
  } else {
    basePath = `${PRIVATE_BASE_URL}/questions`
  }
  if (Object.keys(params).length) {
    const searchParams = new URLSearchParams(params)
    return `${basePath}?${searchParams}`
  } else {
    return basePath
  }
}

const deleteQuestion = (question: UnknownQuestionModel): Promise<UnknownQuestionModel> => {
  return deleteQuestionById(question.id)
} //

const deleteQuestionById = (id: string): Promise<UnknownQuestionModel> => {
  return API.delete<UnknownQuestionModel>(template(id)).then(responseQuestion => {
    alertSuccess(unknownQuestionsAPIMessages.deleted)
    return responseQuestion
  })
}

const getQuestion = (questionId: string): Promise<UnknownQuestionModel> => {
  return API.get<UnknownQuestionModel>(template(questionId)).then(responseQuestion => {
    return responseQuestion
  })
}

const trainQuestion = (options: UnknownQuestionTrainOptions, withAlert = true): Promise<UnknownQuestionModel> => {
  return API.post(template('train', options)).then(responseQuestion => {
    if (withAlert) alertSuccess(unknownQuestionsAPIMessages.trained)
    return responseQuestion
  })
}

const fetchQuestionTypes = (): Promise<GetDatasetTypesResponse> => {
  return API.get(template('dataset-types'))
}

const updateQuestion = (question: UnknownQuestionUpdateAPI, withAlert = true): Promise<any> => {
  return API.put(template(), question).then(responseQuestion => {
    if (withAlert) alertSuccess(unknownQuestionsAPIMessages.updated)
    return responseQuestion
  })
}

const searchQuestions = async (params: UnkownQuestionsSearchAPI): Promise<UnknownQuestionPaginateAPIRepsonse> => {
  const requestUrl = template('', params)
  return API.get(requestUrl)
}

const getAlertMessageForQuestionCreate = (train: boolean) => {
  return train ? unknownQuestionsAPIMessages.createdAndTrained : unknownQuestionsAPIMessages.created
}

const createQuestion = async (body: UnknownQuestionCreateAPI, withAlert = true) => {
  const requestUrl = template('')
  // todo: remove request type, it is a temporary fix
  // @ts-ignore
  body.requestType = 'TRAIN_UNKNOWN_QUESTION'
  return API.post<UnknownQuestionModel>(requestUrl, body).then(responseQuestion => {
    if (withAlert) alertSuccess(getAlertMessageForQuestionCreate(body.train))
    return responseQuestion
  })
}

const exportQuestions = async (params: UnkownQuestionsSearchAPI): Promise<Blob> => {
  return await API.binaryPost(template('file/export', params)).then(response => {
    alertSuccess(unknownQuestionsAPIMessages.exported)
    return response
  })
}

const uploadQuestionsFromFile = async (body: FormData): Promise<QuestionImportDetailsDTO> => {
  return fetch(template('file/import'), {
    credentials: 'include',
    method: 'POST',
    body: body,
  })
    .then(async response => {
      if (!response.ok) {
        const errorMessage = `Error ${response.status}: ${response.statusText}`
        alertError('Sorry but something is going wrong please ping support!')
        throw new Error(errorMessage)
      }
      return response.json()
    })
    .then(data => {
      alertSuccess(unknownQuestionsAPIMessages.imported)
      return data?.data as QuestionImportDetailsDTO
    })
}

export const unknownQuestionService = {
  deleteQuestion,
  trainQuestion,
  updateQuestion,
  searchQuestions,
  createQuestion,
  fetchQuestionTypes,
  exportQuestions,
  uploadQuestionsFromFile,
  getQuestion,
  deleteQuestionById
}
